import { render, staticRenderFns } from "./LoginRecord.vue?vue&type=template&id=50a95b21&scoped=true"
import script from "./LoginRecord.vue?vue&type=script&lang=js"
export * from "./LoginRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a95b21",
  null
  
)

export default component.exports